import { QueueCountBadge } from '@/components/common/QueueCountBadge'
import { NewTicketButton } from '@/components/common/NewTicketButton'
import { useNavigate } from 'react-router-dom'
import { ExportButton } from '@/components/common/ExportButton'
import { PageHeader } from '@/components/common/PageHeader'
type Props = {
  totalCount?: number
}

export function ParentTicketHeader({ totalCount }: Props) {
  const navigate = useNavigate() 

  return (
  <PageHeader
    mb={4}
    start={
      typeof totalCount === 'number' ? (
        <QueueCountBadge label="Total Requests" count={totalCount} />
      ) : null
    }
    end={
      <>
        <ExportButton isDisabled={!(totalCount && totalCount > 0)} />
        <NewTicketButton onClick={() => navigate('/tickets/create')} />
      </>
    }
  />
)

}
